module.exports = __webpack_public_path__ + "static/media/lion.19b11f2d.png";